var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoomSize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5012",
    "data-name": "Group 5012",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.697,
    height: 24.697,
    viewBox: "0 0 24.697 24.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6113",
    "data-name": "Path 6113",
    d: "M0,0H24.7V24.7H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6114",
    "data-name": "Path 6114",
    d: "M3,5H14.32",
    transform: "translate(0.087 0.145)",
    fill: "none",
    stroke: "#4d677e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6115",
    "data-name": "Path 6115",
    d: "M12,7.116l2.058-2.058L12,3",
    transform: "translate(0.349 0.087)",
    fill: "none",
    stroke: "#4d677e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6116",
    "data-name": "Path 6116",
    d: "M5.058,3,3,5.058,5.058,7.116",
    transform: "translate(0.087 0.087)",
    fill: "none",
    stroke: "#4d677e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6117",
    "data-name": "Path 6117",
    d: "M19,10V21.32",
    transform: "translate(0.552 0.291)",
    fill: "none",
    stroke: "#4d677e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6118",
    "data-name": "Path 6118",
    d: "M17,19l2.058,2.058L21.116,19",
    transform: "translate(0.494 0.552)",
    fill: "none",
    stroke: "#4d677e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6119",
    "data-name": "Path 6119",
    d: "M21.116,12.058,19.058,10,17,12.058",
    transform: "translate(0.494 0.291)",
    fill: "none",
    stroke: "#4d677e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6120",
    "data-name": "Path 6120",
    d: "M3,10m0,2.058A2.058,2.058,0,0,1,5.058,10h7.2a2.058,2.058,0,0,1,2.058,2.058v7.2a2.058,2.058,0,0,1-2.058,2.058h-7.2A2.058,2.058,0,0,1,3,19.261Z",
    transform: "translate(0.087 0.291)",
    fill: "none",
    stroke: "#4d677e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSize);
export default __webpack_public_path__ + "static/media/room-size.2e6cc3f9.svg";
export { ForwardRef as ReactComponent };